import React, { useState } from "react";
import { Link } from "wouter";
import { AxiosError } from 'axios';
import { XCircleIcon, EyeIcon, EyeSlashIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import { singupShort } from "../services/api"



export default function Registrazione() {
  const dataRef = React.useRef({});
  const errorRef = React.useRef(null);
  const successRef = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [typology, setTypology] = useState("");
  const [error, setError] = useState(null);


  React.useEffect(() => {
    if(error) {
        errorRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [error]);

  React.useEffect(() => {
    if(success) {
        successRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [success]);

  const togglePasswordVisibility = () => {
      setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
      setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleTypologyChange = (e) => {
    setTypology(e.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);

    if (!termsChecked || !privacyChecked) {
      setError('Termini e Privacy sono obbligatori');
      return;
    }

    if (typology === "A" && !event.target.business_name.value) {
        setError("Il campo Denominazione è obbligatorio per la tipologia Azienda.");
        return;
    }

    const fields = Array.from(dataRef.current.querySelectorAll('input, select')).reduce((prev, curr) => {
        console.log(prev, curr)
        prev[curr.id] = curr.value

        return prev;
    }, {});

    const formData = {
      email: fields.email,
      first_name: fields.first_name,
      last_name: fields.last_name,
      business_name: fields?.business_name,
      phone: fields.phone,
      password: fields.password,
      password_confirm: fields.password_confirm,
      typology: fields.typology,
    };

    setLoading(true);

    try {
      const response = await singupShort(formData);
      setSuccess(true);
      console.log("Registrazione avvenuta con successo", response);
    } catch (error) {
      setError(error.response.data.error);
      console.error("Errore durante la registrazione", error);
    } finally {
      setLoading(false);

    }
};


return (
    <main id="theme-main">
        <style>{`
            .underline_line {
                background: url('data:image/svg+xml,<svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" width="204" height="14" viewBox="0 0 204 14" fill="none"><path d="M15.8184 4.31317C76.5778 6.93773 137.436 6.16547 198.11 2L20.4411 12L202 7.16726C135.326 9.52313 68.6809 6.8968 2 9.25979" stroke="url(%23paint0_linear_884_20)" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><defs><linearGradient id="paint0_linear_884_20" x1="2" y1="7" x2="202" y2="7" gradientUnits="userSpaceOnUse"><stop stop-color="%23EFF1FC"/><stop offset="0.171767" stop-color="%23CDD7FB"/><stop offset="1" stop-color="%234C78F8"/></linearGradient></defs></svg>') bottom center / 100% 0.25em no-repeat;
                box-decoration-break: clone;
                -webkit-box-decoration-break: clone;
                padding-bottom: 0.1em;
                text-decoration: none;
            }
        `}</style>
        
        <div className="min-h-screen bg-[#eff1fc] flex flex-col">
            <div className="flex justify-center py-4 lg:py-6">
                <Link to="/" className="flex items-center">
                    <img src="https://consultalahr.com/wp-content/uploads/2024/12/consultala-logo.png" width="200" height="50" className="wp-image-79" srcSet="https://consultalahr.com/wp-content/uploads/2024/12/consultala-logo.png 657w, https://consultalahr.com/wp-content/uploads/2024/12/consultala-logo-300x46.png 300w" sizes="(max-width: 657px) 100vw, 657px" /> 
                    <span className="text-[#4b5dc8] text-xl font-extrabold self-center -ms-1">HR</span>
                </Link>
            </div>
            <div className="flex-1 flex items-start">
            <div className="w-full lg:max-w-7xl mx-auto lg:mt-6 shadow-sm grid lg:flex rounded-sm overflow-hidden">
                <div className="lg:w-3/4 bg-white p-5 lg:p-10 border">
                    <div className="lg:max-w-lg text-center lg:text-start ">
                        <p className="text-sm text-gray-500 mb-2">Pochi passi per cominciare a gestire i dipendenti in maniera digitalizzata.</p>
                        <h1 className="text-2xl lg:text-5xl font-semibold text-slate-900 mb-8 tracking-tight">Comincia oggi la tua <span className="underline_line">Prova Gratuita</span> di 15 giorni.
                        </h1>
                    </div>

                    {error && (
                        <div className="rounded-md bg-red-50 p-4 mb-6">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <XCircleIcon className="h-5 w-5 text-red-400" />
                                </div>
                                <div className="ml-3">
                                    <h3 className="text-sm font-medium text-red-800" ref={errorRef}>
                                        {error}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    )}

                    {success ? (
                        <>
                            <div className="rounded-md bg-green-50 p-4 mb-6">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <CheckCircleIcon className="h-5 w-5 text-green-400" />
                                    </div>
                                    <div className="ml-3">
                                        <h3 className="text-sm font-medium text-green-800" ref={successRef}>
                                                Registrazione avvenuta con successo!{" "}Hai ricevuto una email con le credenziali.{" "}
                                            <Link
                                                to="/login"
                                                className="text-indigo-600 underline"
                                            >
                                                Clicca qui per effettuare il login.
                                            </Link>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <form onSubmit={handleSubmit} ref={dataRef} className="space-y-6 lg:max-w-xl">
                            <div>
                                <div className="mb-4">
                                    <label
                                        className="block text-gray-700 text-sm font-bold mb-2"
                                        htmlFor="typology"
                                    >
                                        Tipologia
                                    </label>
                                    <select
                                        className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                        id="typology"
                                        placeholder="typology"
                                        onChange={handleTypologyChange}
                                        required
                                    >
                                        <option value="">---</option>
                                        <option value="A">Azienda</option>
                                        <option value="PF">Persona fisica</option>
                                    </select>
                                </div>

                                <div className="mb-4">
                                    <label
                                        className="block text-gray-700 text-sm font-bold mb-2"
                                        htmlFor="email"
                                    >
                                        Email
                                    </label>
                                    <input
                                        className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                        id="email"
                                        type="email"
                                        placeholder="Email"
                                        required
                                    />
                                </div>

                                <div className="lg:flex lg:gap-3">
                                    <div className="mb-4 lg:w-1/2">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="first_name"
                                        >
                                            Nome
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="first_name"
                                            type="text"
                                            placeholder="Nome"
                                            required
                                        />
                                    </div>
                                    <div className="mb-4 lg:w-1/2">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="last_name"
                                        >
                                            Cognome
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="last_name"
                                            type="text"
                                            placeholder="Cognome"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label
                                        className="block text-gray-700 text-sm font-bold mb-2"
                                        htmlFor="business_name"
                                    >
                                        Denominazione Azienda
                                    </label>
                                    <input
                                        className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                        id="business_name"
                                        type="text"
                                        placeholder="Denominazione Azienda"
                                    />
                                </div>

                                <div className="mb-4">
                                    <label
                                        className="block text-gray-700 text-sm font-bold mb-2"
                                        htmlFor="phone_number"
                                    >
                                        Telefono
                                    </label>
                                    <input
                                        className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                        id="phone"
                                        type="tel"
                                        placeholder="Telefono"
                                        required
                                    />
                                </div>

                                <div className="lg:flex lg:gap-3">
                                    <div className="mb-4 relative lg:w-1/2">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="password"
                                        >
                                            Password
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="password"
                                            type={passwordVisible ? 'text' : 'password'}
                                            placeholder="Password"
                                            style={{ backgroundColor: 'white' }}
                                            required
                                        />
                                        <div
                                            className="absolute inset-y-0 right-0 top-1/2 lg:top-5 flex items-center px-2 cursor-pointer"
                                            onClick={togglePasswordVisibility}
                                        >
                                            {passwordVisible ? (
                                                <EyeSlashIcon className="h-5 w-5 text-gray-700" />
                                            ) : (
                                                <EyeIcon className="h-5 w-5 text-gray-700" />
                                            )}
                                        </div>
                                    </div>
                                    <div className="mb-6 relative lg:w-1/2">
                                        <label
                                            className="block text-gray-700 text-sm font-bold mb-2"
                                            htmlFor="confirm-password"
                                        >
                                            Conferma Password
                                        </label>
                                        <input
                                            className="shadow-md appearance-none border border-gray-200 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-indigo-200 placeholder:text-sm"
                                            id="password_confirm"
                                            type={confirmPasswordVisible ? 'text' : 'password'}
                                            placeholder="Conferma Password"
                                            required
                                        />
                                        <div
                                            className="absolute inset-y-0 right-0 top-1/2 flex items-center px-2 cursor-pointer"
                                            onClick={toggleConfirmPasswordVisibility}
                                        >
                                            {confirmPasswordVisible ? (
                                                <EyeSlashIcon className="h-5 w-5 text-gray-700" />
                                            ) : (
                                                <EyeIcon className="h-5 w-5 text-gray-700" />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-6">
                                    <label className="inline-flex items-center text-gray-700">
                                        <input
                                            type="checkbox"
                                            id="terms"
                                            className="rounded border-gray-300 shadow-md text-indigo-600 focus:ring-indigo-600"
                                            checked={termsChecked}
                                            onChange={(e) => setTermsChecked(e.target.checked)}
                                            required
                                        />
                                        <span className="text-gray-700 text-sm font-bold ml-2">Accetto le <a href="https://consultala.com/termini/" target="_blank" className="text-indigo-600 hover:underline">Condizioni Generali</a></span>
                                    </label>
                                </div>
                                
                                <div className="mb-6">
                                    <label className="inline-flex items-center text-gray-700">
                                        <input
                                            type="checkbox"
                                            id="privacy"
                                            className="rounded border-gray-300 shadow-md text-indigo-600 focus:ring-indigo-600"
                                            checked={privacyChecked}
                                            onChange={(e) => setPrivacyChecked(e.target.checked)}
                                            required
                                        />
                                        <span className="text-gray-700 text-sm font-bold ml-2">Accetto la <a href="https://consultala.com/privacy/" target="_blank" className="text-indigo-600 hover:underline">Privacy Policy</a></span>
                                    </label>
                                </div>
                            </div>
                            <div className="grid mt-8 max-w-xl">
                                {loading ? (
                                    <button
                                        type="button"
                                        className="bg-indigo-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        disabled
                                    >
                                        <svg
                                        className="animate-spin h-5 w-5 mr-3"
                                        viewBox="0 0 24 24"
                                        >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                            fill="none"
                                        />
                                        </svg>
                                        Elaborazione...
                                    </button>
                                ) : (
                                    <button
                                        type="submit"
                                        className="bg-indigo-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        disabled={success}
                                    >
                                        Crea Account
                                    </button>
                                )}
                            </div>
                        </form>
                    )}
                </div>
                
                <div className="lg:w-2/4 relative bg-indigo-900 text-white p-12 overflow-hidden " style={{backgroundImage:"url('https://dev.consultala.com/static/landing_hr/assets/img/svg.png')", backgroundSize:'cover'}}>
                    <p className="text-xl lg:text-3xl  mb-8">Ti aiutiamo noi!&nbsp;Un Team di <strong>esperti</strong> sempre al fianco della tua Azienda.</p>
                    
                    <ul className="space-y-6 mb-8">
                        <li className="flex">
                            <div className="flex-shrink-0 mr-4">
                                <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold">Gestione Presenze e Timbratura</div>
                                <p className="text-sm text-white/90 mt-1">Imposta i turni del tuo organico, permetti ai tuoi dipendenti di timbrare comodamente dal proprio smartphone ed esporta a fine mese il report delle presenze.</p>
                            </div>
                        </li>
                        
                        <li className="flex">
                            <div className="flex-shrink-0 mr-4">
                                <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold">Giustificativi sotto controllo</div>
                                <p className="text-sm text-white/90 mt-1">Gestisci tutte le richieste di ferie, permessi e molti altri ancora direttamente dal tuo portale aziendale e notifica i dipendenti in tempo reale.&nbsp;</p>
                            </div>
                        </li>
                        
                        <li className="flex">
                            <div className="flex-shrink-0 mr-4">
                                <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold">Cedolini e CU tramite APP</div>
                                <p className="text-sm text-white/90 mt-1">Archivia, trasmetti, e visualizza le buste paga, le certificazioni uniche e tutta la documentazione dei tuoi dipendenti in modo rapido e sicuro.&nbsp;</p>
                            </div>
                        </li>
                        
                        <li className="flex">
                            <div className="flex-shrink-0 mr-4">
                                <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div className="font-semibold">Note spese e Rimborsi</div>
                                <p className="text-sm text-white/90 mt-1">Gestisci tutte le richieste di rimborso dei tuoi dipendenti da un'unica schermata o inserisci rapidamente qualsiasi tipo di rimborso spesa o chilometrico.</p>
                            </div>
                        </li>
                    </ul>
                    
                    <div className="mt-auto flex gap-3 border rounded p-2 border-indigo-400 border-opacity-65 lg:mt-14">
                        <div className="lc-block shrink-0">
                            <img className="img-fluid wp-image-2321" src="https://consultalahr.com/wp-content/uploads/2025/07/donna_busta_paga_soluzione-300x300.webp" width="112" height="112" srcSet="https://consultalahr.com/wp-content/uploads/2025/07/donna_busta_paga_soluzione-300x300.webp 300w, https://consultalahr.com/wp-content/uploads/2025/07/donna_busta_paga_soluzione-150x150.webp 150w, https://consultalahr.com/wp-content/uploads/2025/07/donna_busta_paga_soluzione-768x768.webp 768w, https://consultalahr.com/wp-content/uploads/2025/07/donna_busta_paga_soluzione.webp 1024w" sizes="(max-width: 300px) 100vw, 300px" />
                        </div>
                        <h3 className="lg:text-xl font-semibold">Nessun metodo di pagamento richiesto per iniziare la tua Prova Gratuita!</h3>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </main>
  )
}